const reduced = () => typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

/**
 * "Pack flies into the cart": clones the product photo and animates it to the
 * visible cart icon (bottom nav or top bar, marked with data-cart-target).
 * Purely decorative — silently does nothing when motion is reduced.
 */
export function flyToCart(source: Element | null): void {
  if (!source || reduced()) return;
  const targets = Array.from(document.querySelectorAll<HTMLElement>("[data-cart-target]")).filter((el) => el.offsetParent !== null);
  const target = targets[targets.length - 1];
  if (!target) return;
  const from = source.getBoundingClientRect();
  const to = target.getBoundingClientRect();
  if (!from.width || !to.width) return;
  const ghost = (source.tagName === "IMG" ? source : source.querySelector("img"))?.cloneNode(true) as HTMLElement | undefined;
  if (!ghost) return;
  const size = Math.min(from.width, 140);
  Object.assign(ghost.style, {
    position: "fixed",
    left: `${from.left + from.width / 2 - size / 2}px`,
    top: `${from.top + from.height / 2 - size / 2}px`,
    width: `${size}px`,
    height: `${size}px`,
    objectFit: "contain",
    zIndex: "200",
    pointerEvents: "none",
    mixBlendMode: "multiply",
    transform: "none",
    padding: "0",
  });
  document.body.appendChild(ghost);
  const dx = to.left + to.width / 2 - (from.left + from.width / 2);
  const dy = to.top + to.height / 2 - (from.top + from.height / 2);
  const anim = ghost.animate(
    [
      { transform: "translate(0,0) scale(1)", opacity: 1 },
      { transform: `translate(${dx * 0.5}px, ${dy * 0.5 - 60}px) scale(0.55)`, opacity: 0.9, offset: 0.55 },
      { transform: `translate(${dx}px, ${dy}px) scale(0.12)`, opacity: 0.2 },
    ],
    { duration: 650, easing: "cubic-bezier(.45,.05,.3,1)" },
  );
  anim.onfinish = () => {
    ghost.remove();
    target.animate([{ transform: "scale(1)" }, { transform: "scale(1.22)" }, { transform: "scale(1)" }], { duration: 260 });
  };
}
